<template>
  <main class="app">
    <top :title="title"></top>
    <view></view>
    <grid :columns.sync="columns"></grid>
    <symbols></symbols>
  </main>
</template>


<script>
import store from './vuex/store'
import Top from './components/Top.vue'
import View from './components/View.vue'
import Grid from './components/Grid.vue'
import Symbols from './components/Symbols.vue'
import { title } from './vuex/view/getters'
import { host } from 'src/api/resources'

export default {
  data () {
    return {
      columns: 24
    }
  },
  components: {
    Grid,
    Symbols,
    View,
    Top
  },
  store,
  vuex: {
    getters: {
      title
    }
  },
  created() {
    document.title = (host === 'mindsocial' ? 'MindSocial App' : 'Fuht App')
  }
}
</script>


<style lang="scss">
@import './scss/style';

html, body {
  height: 100%;
}
body {
  min-height: 100%;
}
.app {
  background-color: inherit;
  min-height: 100%;
  @include gutter($gutter-border, (margin-left, margin-right));
}
</style>



// WEBPACK FOOTER //
// App.vue?cfd5897e